import axios from 'axios';

const hotelContainerEls = document.querySelectorAll('.js-hotel-prices a');
const hotelIndividualPriceEl = document.querySelector('.js-hotel-price');

const fetchHotelResults = (atcomRef, start, end) => {
	return new Promise((resolve) => {

		const baseUrl = document.body.dataset?.bookingApiUrl;
		if (!baseUrl) {
			console.error('"data-booking-api-url" data attribute must be defined on the body tag.');
			resolve({ data: {} });
			return;
		}

		const url = new URL(`${baseUrl}/api/v1/hotel/prices?startDate=${start}&endDate=${end}&code=${atcomRef}&includeMonths=1`);

		axios
			.get(url)
			.then((response) => {
				resolve(response.data);
			})
			.catch((error) => {
				console.error(error);
			});
	});
};

const getNext12Months = () => {
	const currentDate = new Date();
	const startOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth() + 0, 1);
	const endOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth() + 12 + 1, 0);
	const returnAr = [startOfMonth.toISOString().split('T')[0], endOfMonth.toISOString().split('T')[0]];
	return returnAr;
};

const findLowestCost = (data) => {
	return Object.values(data).reduce((minCost, cost) => {
		if (cost !== '' && (minCost === null || cost < minCost)) {
			return cost;
		}
		return minCost;
	}, null);
};

if (hotelContainerEls.length) {
	hotelContainerEls.forEach((hotelContainerEl) => {
		const hotelAtcomRef = hotelContainerEl.getAttribute('data-atcom');
		const hotelPriceEl = hotelContainerEl.querySelector('#hotel-price');
		const hotelPricePartentEl = hotelContainerEl.querySelector('div p.price-from');
		const dates = getNext12Months();

		fetchHotelResults(hotelAtcomRef, dates[0], dates[1]).then((response) => {
			const { data } = response;
			if (data) {
				const lowestPrice = findLowestCost(data) / 2;
				if (lowestPrice > 0) {
					hotelPriceEl.innerHTML = `£${parseFloat(parseFloat(lowestPrice).toFixed(0)).toLocaleString()} <sub class="bottom-0 text-base md:text-lg font-bold tracking-tight text-dark-grey text-body font-body !leading-extra-tight"> per person</sub>`;
				} else {
					hotelPricePartentEl.setAttribute('hidden', 'hidden');
				}
			}
		});
	});
}

if (hotelIndividualPriceEl) {
	const hotelAtcomRef = hotelIndividualPriceEl.getAttribute('data-atcom');
	const dates = getNext12Months();

	fetchHotelResults(hotelAtcomRef, dates[0], dates[1]).then((response) => {
		const { data } = response;
		if (data) {
			const lowestPrice = findLowestCost(data) / 2;
			if (lowestPrice > 0) {
				hotelIndividualPriceEl.innerHTML = `From £${parseFloat(parseFloat(lowestPrice).toFixed(0)).toLocaleString()} pp per night`;
			} else {
				hotelIndividualPriceEl.setAttribute('hidden', 'hidden');
			}
		}
	});
}
